import { Refund } from '../Refunds/types';

export enum PaymentAgreementType {
  Tuition = 'tuition',
  Tariff = 'tariff',
}

/**
 * Unified row consumed by the Cuenta corriente table. Pending refunds are
 * rendered inline alongside debts (XD HU-15415): debt rows render as before,
 * refund rows show the refund concept/date in the Cargo column, the gross
 * amount in Abono, the available balance highlighted in Deuda, and an
 * "Aplicar devolución" button in Acción. Most other cells render N/A for
 * refunds.
 */
export type DebtTableRow =
  | ({ __kind: 'debt' } & Debt)
  | { __kind: 'refund'; id: string; refund: Refund };

export interface Debt {
  //identificador de la deuda
  id: number;
  //Corresponde a una descripción, cada deuda puede definir su concepto en su Mapper
  concept: string;
  //Tipo de acuerdo de momento tenemos arancel y matricula, pero luego vinen las repactaciones
  agreementType: PaymentAgreementType;
  //Nº de cuota: ejemplo 1/7(uno de siete cuotas)
  numberOfInstallment: string;
  //Fecha de vencimiento de la cuota
  expirationDate: string;
  //dias de atraso(días de mora)
  daysLate: number;
  //Monto total de la deuda
  capitalAmount: number;
  interestRate: number;
  interestAmount: number;
  totalAmount: number;
  paidAmount: number;
  outstandingDebt: number;
  studyPlanId: number | null;
  studyPlanName: string | null;
  year: number;
  period: number | null;
  periodId: number | null;
  periodName: string | null;
  idToDisplay: string | null;
  collectionFees: number;
}

export enum StudentFinancialStatusCode {
  Active = 'active',
  FinancialBlock = 'financialBlock',
  TemporaryUnblock = 'temporaryUnblock',
}

export interface StudentFinancialStatus {
  status: StudentFinancialStatusCode;
  temporaryUnblockUntil: string | null;
}

export interface DebtResponse {
  studentFinancialStatus: StudentFinancialStatus;
  debts: Debt[];
}

// HU #15319 — available filter statuses. Mirrors the API enum
// `CurrentAccountDebtFilterStatus` so values are serialized as-is to the
// `status` query param.
export enum DebtStatusFilter {
  Pending = 'pending',
  Overdue = 'overdue',
  Paid = 'paid',
}

// Draft/applied filter state for the DebtFilters component.
// `null` means "no filter applied on this dimension".
export interface DebtFiltersState {
  year: number | null;
  period: number | null;
  studyPlanId: number | null;
  status: DebtStatusFilter | null;
}

export const EMPTY_DEBT_FILTERS: DebtFiltersState = {
  year: null,
  period: null,
  studyPlanId: null,
  status: null,
};

// HU #15322 — charge item from GET /charges/items
export interface ChargeItem {
  id: number;
  name: string;
  costCenter: string | null;
  currency: string | null;
  amount: number | null;
}

// HU #15322 — body for POST /students/:studentId/charges
export interface CreateChargeBody {
  studyPlanId: number;
  periodId: number;
  chargeItemId?: number | null;
  concept?: string;
  expirationDate: string;
  costCenter?: string;
  currency?: string;
  amount?: number;
}
